import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import Login from "@/pages/Login";
import SetPassword from "@/pages/SetPassword";
import Dashboard from "@/pages/Dashboard";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import Appointments from "@/pages/Appointments";
import Agenda from "@/pages/Agenda";
import BloodDraws from "@/pages/BloodDraws";
import Report from "@/pages/Report";
import Administration from "@/pages/Administration";
import Studios from "@/pages/Studios";
import Messages from "@/pages/Messages";
import PatientPortal from "@/pages/PatientPortal";
import AppointmentResponse from "@/pages/AppointmentResponse";

const Loading = () => (
  <div className="min-h-screen grid place-items-center text-[#3d655b]" data-testid="app-loading">
    <div className="h-10 w-10 rounded-full border-4 border-[#edf2ef] border-t-[#3d655b] animate-spin" />
  </div>
);

function RequireRole({ role, children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== role) return <Navigate to={user.role === "admin" ? "/" : "/area-paziente"} replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/imposta-password" element={<SetPassword />} />
          <Route path="/appuntamento" element={<AppointmentResponse />} />
          <Route path="/area-paziente" element={<RequireRole role="patient"><PatientPortal /></RequireRole>} />
          <Route element={<RequireRole role="admin"><AppShell /></RequireRole>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/pazienti" element={<Patients />} />
            <Route path="/pazienti/:id" element={<PatientDetail />} />
            <Route path="/appuntamenti" element={<Appointments />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/prelievi" element={<BloodDraws />} />
            <Route path="/report" element={<Report />} />
            <Route path="/amministrazione" element={<Administration />} />
            <Route path="/studi" element={<Studios />} />
            <Route path="/messaggi" element={<Messages />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
